import { FaClone } from "react-icons/fa";
import Tooltip from "../ToolTip";

const DuplicateButton = ({ action, content }) => {
  return (
    <Tooltip content={content}>
      <button
        onClick={() => action()}
        className="p-1.5 text-purple-500 hover:bg-purple-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-purple-700 bg-opacity-10 flex transition-all duration-100 items-center"
      >
        <FaClone className="text-[10px]"/>
      </button>
    </Tooltip>
  )
}

export default DuplicateButton;
